/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Preview_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not preview upgrade." |
*
* @param {Sub_Dashboard_Preview_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_preview_error = /** @type {((inputs?: Sub_Dashboard_Preview_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Preview_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade-Vorschau konnte nicht geladen werden.")
	return /** @type {LocalizedString} */ ("Could not preview upgrade.")
});